import script from "./EditorAlignDropdown.vue?vue&type=script&setup=true&lang=ts"
export * from "./EditorAlignDropdown.vue?vue&type=script&setup=true&lang=ts"

import "./EditorAlignDropdown.vue?vue&type=style&index=0&id=682b3bee&lang=scss"

const __exports__ = script;

export default __exports__